import React, { Component } from "react";
import FakeData from ".././fake-data";
import { Link } from "react-router-dom";

import {
  FilterView,
  ShimmerView,
  SetTournGameModal,
  ItemPicker,
  Modal,
  ComboBox,
  PhotoAddModal,
  TagView,
  MomentPickerModal,
  EditGameModal,
  PlayOffView,
  UpcominComingGames,
  EmptyState
} from "./Common";

import RichTextInputField from './RichTextInputField';

const { $, moment } = window;
const EventSource = window.EventSource;

export class TimeLineFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "",
      currentView: "Friends",
      currentFilter: "",
      currentUser: {id:null}
    };
  }

  filter(fil, user = false) {
    this.setState({
      active: fil
    });
    this.props.onFilter(fil, user);
  }

  render() {
    //console.log(FakeData.getData("game-banner"));
    const { currentView, currentFilter, currentUser } = this.state;
    if (!this.is) {
      return (
        <div
          className="timeline-filters"
          style={{
            position: this.props.isEmbed?"relative":"",
            width: this.props.isEmbed?"100%":"",
            top:
            this.props.isEmbed?"0px":500 - this.props.offset <= 70
                ? "70px"
                : 500 - this.props.offset + "px"
          }}
        >
          <div
            className="home-user-filters"
            style={{
              marginBottom: 10,
              marginTop: this.props.isEmbed?"10px":"",
              width: this.props.isEmbed?"100%":"96%"
            }}
          >
            <a
              className={currentView === "Friends" ? "active" : ""}
              onClick={() => {
                this.setState({ currentView: "Friends" });
                this.filter("friends")
              }}
            >
              <img src="images/who_sees_friends.svg" alt="Friends" />
            </a>
            <a
              className={
                currentView === "Fans"
                  ? "active"
                  : ""
              }
              onClick={() => {
                this.setState({ currentView: "Fans" });
                this.filter("fans")
              }}
            >
              <img
                src="images/facebook-group.svg"
                alt="Groups"
                style={{
                  background: "#58CC66",
                  borderRadius: "100px",
                  padding: "2px"
                }}
              />
            </a>
            <a
              className={currentView === "Rivals" ? "active" : ""}
              onClick={() => {
                this.setState({ currentView: "Rivals" });
                this.filter("rivals")
              }}
            >
              <img src="images/who_sees_game.svg" alt="Team" />
            </a>
          </div>
          <div
            className="home-user-body-filters"
            style={{
              marginBottom: 10,
              width: this.props.isEmbed?"100%":"96%"
            }}
          >
            <div className="home-user-body-filters-search">
              <i className="material-icons">search</i>
              <input
                placeholder="Search"
                value={currentFilter}
                onChange={e => {
                  this.setState({ currentFilter: e.target.value });
                }}
              />
            </div>
            <div className="home-user-body-filters-ctx" style={{
              overflow:this.props.isEmbed?"hidden":"",
              overflowY:this.props.isEmbed?"auto":"",
              height:this.props.isEmbed?"calc(100vh - 100px":"",
            }}>
            {currentView === "Friends" &&
                FakeData.nullify("")
                  .toLowerCase()
                  .indexOf(currentFilter.toLowerCase()) > -1 && (
                  <div
                    className={"home-user-body-filters-ctx-item"}
                    onClick={() => {
                      this.setState({
                        currentUser: {
                          id: null
                        }
                      });

                      this.filter("friends", false)
                    }}
                  >
                    <img src={FakeData.apiURL+"/default_avatar.svg"} />
                    <span>{"All"}</span>
                  </div>
                )}
              {currentView === "Friends" &&
                FakeData.nullify(FakeData.getData("yoo").name)
                  .toLowerCase()
                  .indexOf(currentFilter.toLowerCase()) > -1 && (
                  <div
                    className={
                      currentUser.id === FakeData.getData("yoo").id &&
                      currentUser.type === "F"
                        ? "home-user-body-filters-ctx-item active"
                        : "home-user-body-filters-ctx-item"
                    }
                    onClick={() => {
                      this.setState({
                        currentUser: {
                          id: FakeData.getData("yoo").id,
                          type: "F",
                          noPreview: true
                        }
                      });

                      this.filter("friends", {
                        id: FakeData.getData("yoo").id,
                        type: "F",
                        noPreview: true
                      })
                    }}
                  >
                    <img src={FakeData.getData("yoo").image} />
                    <span>{"You"}</span>
                  </div>
                )}
              {currentView === "Friends" &&
                FakeData.getData("yoo")
                  .friends.filter((item, i) => {
                    return (
                      FakeData.nullify(item.name)
                        .toLowerCase()
                        .indexOf(currentFilter.toLowerCase()) > -1
                    );
                  })
                  .map((item, i) => {
                    return (
                      <div
                        key={i}
                        className={
                          currentUser.id === item.id &&
                          currentUser.type === item.type
                            ? "home-user-body-filters-ctx-item active"
                            : "home-user-body-filters-ctx-item"
                        }
                        onClick={() => {
                          this.setState({
                            currentUser: item
                          });
                          this.filter("friends", item)
                        }}
                      >
                        <img src={item.image} />
                        <span>{item.name}</span>
                      </div>
                    );
                  })}
            </div>
          </div>
          <div className="ad-filter" style={{
            width: "96%",
            display: this.props.isEmbed?"none":""
          }}>
            <img src="images/adverts/bet_now_advert.jpg" />
          </div>
        </div>
      );
    }
    return (
      <div
        className="timeline-filters"
        style={{
          top:
            500 - this.props.offset <= 70
              ? "70px"
              : 500 - this.props.offset + "px"
        }}
      >
        <div className="filter">
          <div
            className={this.state.active === "" ? "active" : ""}
            onClick={() => this.filter("")}
          >
            All
          </div>
          <div
            className={this.state.active === "friends" ? "active" : ""}
            onClick={() => this.filter("friends")}
          >
            Friends
          </div>
          <div
            className={this.state.active === "fan" ? "active" : ""}
            onClick={() => this.filter("fan")}
          >
            Fans
          </div>
          <div
            className={this.state.active === "gmc" ? "active" : ""}
            onClick={() => this.filter("gmc")}
          >
            GMC
          </div>
          <div
            className={this.state.active === "rival" ? "active" : ""}
            onClick={() => this.filter("rival")}
          >
            Rivals
          </div>
        </div>
        <div className="ad-filter">
          <img src="images/adverts/bet_now_advert.jpg" />
        </div>
      </div>
    );
  }
}

export class TimeLineForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      post: {
        content: "",
        team: this.props.game.yourTeam,
        game: this.props.game,
        user: this.props.user,
        media: [],
        tags: [],
        minute: Math.floor(this.props.game.currentTime / 60),
        player: {}
      },
      isCommentOnGMC: false,
      commentID: 0,
      isModalOpen: false,
      isTagging: false,
      tags: [],
      momment: "players",
      isPickingMomment: false
    };

    this.onTextChange = this.onTextChange.bind(this);
    this.onPostComment = this.onPostComment.bind(this);
    this.onAddFiles = this.onAddFiles.bind(this);
    this.onAddTag = this.onAddTag.bind(this);
    this.openMomentPicker = this.openMomentPicker.bind(this);
    this.addPlayerMoment = this.addPlayerMoment.bind(this);
  }

  onTextChange(e) {
    this.state.post.content = e.target.value;
    this.setState({
      post: this.state.post
    });
  }

  onPostComment() {
    if (this.state.post.content === "" && this.state.post.media.length === 0) {
      return;
    }

    const _that = this;
    const dataTo = this.state.post;
    dataTo.user = this.props.user;

    if (this.state.commentID > 0 && this.state.isCommentOnGMC) {
      const dataOf = {
        user: this.props.user,
        postId: this.state.commentID,
        content: this.state.post.content,
        type: this.props.post.isGMC ? "gmc-post" : "game-post",
        media: this.state.post.media[0],
        user: this.props.user,
        userOne: this.props.post.user,
        userTwo: this.props.post.userTo,
        users: this.props.post.tags,
        userType: this.props.userType
      };

      const _that = this;

      FakeData.post(
        "/createComment.php?auth0",
        dataOf,
        {
          success: res => {
            _that.setState({
              post: {
                content: "",
                team: _that.props.game.yourTeam,
                game: _that.props.game,
                user: _that.props.user,
                media: [],
                tags: [],
                minute: Math.floor(_that.props.game.currentTime / 60),
                player: {}
              }
            });
            if (_that.props.hasScrolled) {
              _that.props.onOverlayClose();
            }
            FakeData.alert("Comment was posted!");
          },
          error: err => {}
        },
        true,
        "",
        () => {}
      );
      return;
    }

    FakeData.post(
      "/createGMCPost.php?auth0",
      dataTo,
      {
        success: res => {
          _that.setState({
            post: {
              content: "",
              team: _that.props.game.yourTeam,
              game: _that.props.game,
              user: _that.props.user,
              media: [],
              tags: [],
              minute: Math.floor(_that.props.game.currentTime / 60),
              player: {}
            }
          });
          _that.props.onPostAdded(res);
          FakeData.alert("Post was added!");
          if (_that.props.hasScrolled) {
            _that.props.onOverlayClose();
          }
        },
        error: err => {}
      },
      true,
      "",
      () => {}
    );
  }

  onAddFiles(cap, files) {
    this.state.post.content = cap;
    this.state.post.media = files;
    this.setState({
      post: this.state.post
    });
    this.onPostComment();
  }

  onAddTag(tags) {
    this.state.post.tags = tags;
    this.setState({
      post: this.state.post
    });
  }

  openMomentPicker(key) {
    this.setState({
      momment: key,
      isPickingMomment: true
    });
  }

  addPlayerMoment(players, reaction, moment) {
    //console.log(players,reaction,moment);
    if (players.length === 0) {
      return;
    }

    let filler =
      reaction.value === "Angry" || reaction.value === "Sad" ? " at " : "";
    let val =
      reaction.value === null || reaction.value === ""
        ? ""
        : players.length === 1
          ? reaction.value + filler + " this player, "
          : reaction.value + filler + " these players, ";
    if (players.length === 1) {
      val += players[0].name + ", ";
      this.props.acts.forEach(item => {
        if (
          item.user.id === players[0].id &&
          item.action.toLowerCase() === moment.value.toLowerCase()
        ) {
          //console.log(item);
          /*this.setState({
            isCommentOnGMC:true,
            commentID:item.id,
          });*/
        }
      });
    } else {
      for (let i = 0; i < players.length; i++) {
        const p = players[i];
        if (i === players.length - 1) {
          val += "and " + p.name + ", ";
        } else if (players.length - i === 2) {
          val += p.name + " ";
        } else {
          val += players[i].name + ", ";
        }
      }

      this.setState({
        isCommentOnGMC: true,
        commentID: 0
      });
    }

    const momentVal =
      moment.value === null && moment.value === ""
        ? ""
        : "based on the " + moment.value + " " + moment.filler + ", ";
    this.state.post.content = val + momentVal;
    this.setState({
      post: this.state.post
    });
  }

  render() {
    let posts = [];
    if (this.props.filter === "") {
      posts = this.props.posts;
    } else {
      const newArr = [];
      this.props.posts.forEach(item => {
        if (
          item.type.toLowerCase().indexOf(this.props.filter.toLowerCase()) > -1
        ) {
          newArr.push(item);
        }
      });

      posts = newArr;
    }

    return (
      <div className="timeline-form" style={{
        width: this.props.isFullScreen?"100%":"",
        marginLeft: this.props.isFullScreen?"0":"",
        display: this.props.formOnly?"flex":"",
        justifyContent: this.props.formOnly?"center":""
      }}>
        {(!this.props.isFullScreen || this.props.formOnly) &&
          <div
            className={this.props.hasScrolled ? "this-form overlay" : "this-form"}
          >
            <button
              className="overlay-close"
              style={{
                display: this.props.hasScrolled ? "block" : "none",
                width: "36px",
                height: "36px",
                background: "url(.././lib/fancybox/fancybox_sprite.svg)",
                backgroundSize: "44px 152px!important",
                borderRadius: "100px",
                border: "none",
                position: "absolute",
                top: 0,
                right: 0,
                margin: "-18px"
              }}
              onClick={this.props.onOverlayClose}
            />
            <div className="header-for">
              <h4>Share</h4>
              <div
                className="share-btn"
                onClick={() =>
                  this.setState({
                    isModalOpen: true
                  })
                }
              >
                <img src=".././images/photo_icon_gry.svg" alt="Share Photo" />Photo/Video
              </div>
              <div className="share-btn">
                <img src=".././images/checkin_gry.svg" alt="Where were you?" />Check
                in
              </div>
              <div
                className="share-btn"
                onClick={() =>
                  this.setState({
                    isTagging: this.state.isTagging ? false : true
                  })
                }
              >
                <img
                  src=".././images/tag_icon_gry.svg"
                  alt="Who were you with?"
                />Tag
              </div>
            </div>
            <textarea
              value={this.state.post.content}
              placeholder="Write something..."
              onChange={e => this.onTextChange(e)}
            />
            <TagView
              selected={this.state.post.tags}
              user={this.props.user}
              onAddTag={this.onAddTag}
              isShown={this.state.isTagging}
              isLabel="true"
            />
            <div className="actions-for">
              <div
                className="action-of"
                onClick={() => this.openMomentPicker("players")}
              >
                <span>Player</span>
                <img src=".././images/who_sees_friends.svg" />
              </div>
              <div
                className="action-of"
                onClick={() => this.openMomentPicker("moment")}
              >
                <span>Key Moment</span>
                <img src=".././images/moment_icon.svg" />
              </div>
              <div
                className="action-of"
                onClick={() => this.openMomentPicker("reaction")}
              >
                <span>React</span>
                <img src=".././images/thumbs_icon.svg" />
              </div>
              <div className="button-of" onClick={this.onPostComment}>
                <button>Post</button>
              </div>
            </div>
          </div>
        }

        {(!this.props.formOnly && !this.props.formOnly) && <TimeLineCollection shrinkItems={this.props.shrinkItems?true:false} isLoading={this.props.isLoadingPosts} user={this.props.user} posts={posts} />}
        
        {this.state.isModalOpen &&
          <PhotoAddModal
            toId={this.props.game.id}
            toType={"G"}
            onPost={this.onAddFiles}
            url={
              FakeData.URL + "/uploadMedia.php?auth0&userId=" + this.props.user.id
            }
            user={this.props.user}
            isOpen={this.state.isModalOpen}
            onClose={() =>
              this.setState({
                isModalOpen: false
              })
            }
          />
        }

        {this.state.isPickingMomment &&
        <MomentPickerModal
          game={this.props.game}
          setTab={tab => this.openMomentPicker(tab)}
          activeTab={this.state.momment}
          isOpen={this.state.isPickingMomment}
          onClose={(p, r, m) => {
            this.setState({
              isPickingMomment: false
            });
            this.addPlayerMoment(p, r, m);
          }}
        />
        }
      </div>
    );
  }
}

export class TimeLineCollection extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.isLoading) {
      return (
        <div className="timeline-collection">
          {FakeData.getDummy(10).map((item, i) => {
            return (
              <ShimmerView
                key={i}
                style={{
                  marginTop: i === 0 ? "10px" : 0
                }}
              />
            );
          })}
        </div>
      );
    }

    if (FakeData.listify(this.props.posts).length === 0){
      return(
        <EmptyState style={{
          background: "#fff",
          marginTop: "10px",
        }} isShown={true} text={"No Posts Found!"}/>
      )
    }

    this.props.posts.sort(function(a, b) {
      return b.timestamp - a.timestamp;
    });
    return (
      <div className="timeline-collection">
        {this.props.posts.map((item, i) => (
          <TimeLineCollectionComment
            isFirst={i === 0 ? true : false}
            shrinkItems={this.props.shrinkItems?true:false}
            key={item.id}
            isOdd={i % 2 !== 0 ? false : true}
            post={item}
            user={this.props.user}
            userType="F"
            shimmerStyle={{
              marginTop: i === 0 ? "10px" : 0
            }}
          />
        ))}
      </div>
    );
  }
}

export class TimeLineCollectionComment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowingComments: false,
      hasContent: false,
      post: this.props.post,
      value: "",
      postToken: Date.now(),
      postEditToken: Date.now()+"edit",
      rawContent: "",
      rawEditContent: "",
      media: {},
      file: {},
      commentType: this.props.post.isGMC ? "friends" : ""
    };

    this.onEnter = this.onEnter.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.initSystem();
    this.getSettings();
  }

  componentWillUnmount() {
    this._isMounted = false;
    if(this.system){
      this.system.close()
    }
  }

  getSettings = () => {
		const _that = this;

		FakeData.post('https://supotsu.com:8080/api/settings/get', {
			id: this.props.post.user.id,
			type: this.props.post.user.type
		}, {
				headers: {
					'Content-Type': 'application/json'
				},
				success(settings) {
					_that.setState({ settings });
				}
			})
	}

  likeComment() {
    const dataTo = {
      user: this.props.user,
      type: this.props.post.isGMC ? "gmc-post" : "game-post",
      userOne: this.props.post.user,
      userTwo: this.props.post.userTo,
      contentId: this.props.post.id,
      users: this.props.post.tags,
      userType: "F"
    };

    const _that = this;

    FakeData.post(
      "/likeContent.php?auth0",
      dataTo,
      {
        success: res => {
          FakeData.alert("Done!");
        },
        error: err => {}
      },
      true,
      "",
      () => {}
    );
  }

  onEnter(e, text = false, rawText = false) {
    
    if (e.keyCode === 13 || e.which === 13) {
      if(this.state.isError){
        alert("Please check your content before you submit...")
        return;
      }
      const dataTo = {
        user: this.props.user,
        postId: this.props.post.id,
        content: (!text)?this.state.value:text,
        rawContent: !rawText?this.state.rawContent:rawText,
        type: this.props.post.isGMC ? "gmc-post" : "game-post",
        media: this.state.media,
        userOne: this.props.post.user,
        userTwo: this.props.post.userTo,
        users: this.props.post.tags,
        userType: this.props.userType
      };

      const _that = this;

      FakeData.post(
        "/createComment.php?auth0",
        dataTo,
        {
          success: res => {
            _that.setState({
              value: "",
              media: {},
              isError: false,
              postToken: Date.now(),
              rawContent: "",
              file: {}
            });
            FakeData.alert("Comment was posted!");
          },
          error: err => {}
        },
        true,
        "",
        () => {}
      );
    }
  }

  onSendMedia(media) {
    const dataTo = {
      user: this.props.user,
      postId: this.props.post.id,
      content: "",
      rawContent: "",
      type: this.props.post.isGMC ? "gmc-post" : "game-post",
      media: media,
      userOne: this.props.post.user,
      userTwo: this.props.post.userTo,
      users: this.props.post.tags,
      userType: this.props.userType
    };

    const _that = this;

    FakeData.post(
      "/createComment.php?auth0",
      dataTo,
      {
        success: res => {
          _that.setState({
            media: {},
            file: {}
          });
          FakeData.alert("Comment was posted!");
        },
        error: err => {}
      },
      true,
      "",
      () => {}
    );
  }

  onFilePicked(file) {
    const _that = this;
    let reader = new FileReader();
    reader.onloadend = () => {
      const newFile = {
        file: file,
        progress: 0,
        url: reader.result
      };

      _that.setState({
        file: newFile
      });

      _that.uploadFile(newFile);
    };
    reader.readAsDataURL(file);
  }

  uploadFile(file) {
    var formdata = new FormData();
    const _that = this;
    formdata.append("file", file.file);
    formdata.append("location", "");
    formdata.append("albumId", 0);
    formdata.append("tags", "");
    formdata.append("userId", this.props.user.id);
    var ajax = new XMLHttpRequest();
    ajax.upload.addEventListener(
      "progress",
      e => {
        let percent = Math.round(e.loaded / e.total * 100);
        _that.state.file.progress = percent;
        _that.setState({
          files: _that.state.files
        });
      },
      false
    );
    ajax.addEventListener(
      "load",
      e => {
        let data = JSON.parse(e.target.responseText);
        if (data.id) {
          data.oldUrl = file.url;
          _that.onSendMedia(data);
        } else {
          _that.setState({ media: {}, file: {} });
          alert("Error uploading file...");
        }
      },
      false
    );
    ajax.open(
      "POST",
      FakeData.URL + "/uploadMedia.php?auth0&userId=" + this.props.user.id
    );
    ajax.send(formdata);
  }

  deleteMedia() {
    const file = this.state.media;
    const _that = this;
    const dataTo = {
      userId: FakeData.getData("yoo").id,
      img: file,
      tags: this.state.tags
    };

    FakeData.post(
      "/removeMedia.php?auth0",
      dataTo,
      {
        success: res => {
          _that.setState({
            media: {},
            file: {}
          });
        },
        error: err => {}
      },
      true,
      "File Was Removed",
      res => {}
    );
  }

  setActiveCategory(cat) {
    if (this.state.commentType === cat && this.state.isShowingComments) {
      this.setState({
        isShowingComments: false,
        commentType: ""
      });
    } else if (this.state.commentType === cat) {
      this.setState({
        commentType: ""
      });
    } else {
      this.setState({
        isShowingComments: true,
        commentType: cat
      });
    }
  }

  getItem(array, key) {
    const arr = [];
    array.forEach(item => {
      if (item.type === key) {
        arr.push(item);
      }
    });
    return arr;
  }

  initSystem = () => {
    if (EventSource) {
      const postType = this.props.post.isGMC ? "gmc-post" : "game-post";
      this.system = new EventSource(
        FakeData.fetchURL+
          "/getPost.php?auth0&isPost&userId=" +
          FakeData.getData("yoo").id +
          "&userType=F&type=" +
          postType +
          "&id=" +
          this.props.post.id
      );
      const _that = this;
      if (this.system !== null) {
        //this.system.addEventListener()
        this.system.onmessage = function(e) {
          if (_that._isMounted) {
            this.setState({
              _that: JSON.parse(e.data)
            });
          }
        };

        this.system.addEventListener(
          "open",
          function(e) {
            // Connection was opened.
            //console.log(e)
          },
          false
        );

        this.system.addEventListener(
          "post_update",
          function(e) {
            // Connection was opened.
            if (_that._isMounted) {
              _that.setState({
                post: JSON.parse(e.data),
                hasContent: true
              });
            }
          },
          false
        );

        this.system.addEventListener(
          "error",
          function(e) {
            if (e.readyState == EventSource.CLOSED) {
              // Connection was closed.
            }
          },
          false
        );
      }
    } else {
      console.warn("EventSource Streams not supoorted by browser");
      this.getPost();
    }
  };

  getPost = () => {
    const _that = this;
    const postType = this.props.post.isGMC ? "gmc-post" : "game-post";
    const data = {
      type: postType,
      id: this.props.post.id,
      user: {
        id: FakeData.getData("yoo").id,
        type: "F"
      }
    };

    //console.log(data)

    FakeData.post("/getPost.php?auth0", data, {
      success(res) {
        if (!_that._isMounted) {
          return;
        }

        if (res === null) {
          _that.setState({ error: true, isLoading: false });
        } else {
          _that.setState({ post: res, hasContent: true });
          setTimeout(() => {
            _that.getPost();
          }, 1000);
        }
      },
      error(e) {
        _that.setState({ error: true, isLoading: false });
      }
    });
  };

  render() {
    const post = this.state.post;
    const  shrinkItems = this.props.shrinkItems?true:false;
    const postToken = this.state.postToken
    const _canComment = FakeData.listify(this.state.settings).filter((item) => {
			return item.sub === 'can_comment'
		})
    let can_comment = _canComment.length === 0 ? true : _canComment[0]['value'];
		can_comment = FakeData.you().id === this.props.post.user.id || FakeData.you().id === this.props.post.userTo.id ? true : can_comment;

    if (!this.state.hasContent) {
      return (
        <ShimmerView />
      );
    }

    const friends = this.getItem(this.state.post.comments, "friends");
    const fans = this.getItem(this.state.post.comments, "fans");
    const rival = this.getItem(this.state.post.comments, "rival");

    return (
      <div className="timeline-collection-comment" style={{
        minHeight: shrinkItems?"auto":""
      }}>
        {!this.props.isOdd &&
          !post.isGMC && (
            <div className="author-for">
              <div className="pic" style={{
              height: shrinkItems?"60px":"",
              padding: shrinkItems?"10px":"15px"
            }}>
                <img src={post.user.image} style={{
                  height: shrinkItems?"40px":"",
                  width: shrinkItems?"40px":"",
                }}/>
              </div>
              <div className="clip">
                <img src=".././images/corner_you.svg" />
              </div>
            </div>
          )}
        <div
          className={
            post.isGMC
              ? "content-of gmc-post"
              : this.props.isOdd
                ? "content-of you"
                : "content-of them"
          }
          style={!post.isGMC ? {
            padding: shrinkItems? "15px":""
          } : { ...this.props.gmcStyle }}
        >
          {!post.isGMC && (
            <div className="header-for">
              {post.team.id &&
                post.team.id !== 0 && (
                  <div
                    className={
                      this.props.isOdd ? "chat_team_me" : "chat_team_you"
                    }
                    style={{
                      margin: shrinkItems?(!this.props.isOdd ?"0 -15px 20px 20px":"0 20px 20px -15px"):""
                    }}
                  >
                    <a>
                      <div className="selected_btn rugby" style={{
                        borderRight: shrinkItems?"none":""
                      }}>
                        <img src={post.team.image} alt="Team Name" />
                      </div>
                    </a>
                    {!shrinkItems &&
                      <div className="selected_sport">
                        <Link
                          to={{
                            pathname: "/team/" + post.team.id,
                            search: "?sInit=about"
                          }}
                        >
                          {post.team.name}
                        </Link>
                      </div>
                    }
                  </div>
                )}

              <div
                className={this.props.isOdd ? "author-name you" : "author-name"}
                style={{

                }}
              >
                <h2 style={{
                  fontSize: shrinkItems?"20px":"",
                  marginBottom: shrinkItems?"0px":""
                }}>
                  <Link
                    to={{
                      pathname: "/profile/" + post.user.user,
                      search: "?sInit=about"
                    }}
                  >
                    {post.user.name}
                  </Link>
                </h2>
                <div
                  className={
                    this.props.isOdd ? "author-time you" : "author-time"
                  }
                >
                  {post.isYou &&
                    !post.isGMC && <img style={{
                      height: shrinkItems?"10px":"",
                      width: shrinkItems?"10px":""
                    }} src=".././images/pen_icon_gry.svg" />}
                  <span style={{
                  fontSize: shrinkItems?"10px":""
                }}>{FakeData.moment(post.date).calendar()}</span>
                </div>
              </div>
            </div>
          )}

          {post.isGMC && (
            <div className="header-for-gmc">
              {post.isTeamOne && (
                <div className="team-of">
                  <img src={post.team.image} />
                  <span>{post.team.name}</span>
                </div>
              )}
              <div className={post.isTeamOne ? "admin-of reverse" : "admin-of"}>
                <div className="min">{post.minute + "'"}</div>
                <div className="author">
                  <span>{post.user.name}</span>
                  <span>{post.action}</span>
                </div>
              </div>
              {!post.isTeamOne && (
                <div className="team-of two">
                  <span>{post.team.name}</span>
                  <img src={post.team.image} />
                </div>
              )}
            </div>
          )}
          <div className="body-for">
            <div
              className="body-for-content rich-text-content"
              dangerouslySetInnerHTML={{ __html: FakeData.getRichText(post.rawContent, post.contentUsers) }}
            />
            {post.media.length > 0 && <div className="body-for-media" />}
          </div>
          {!post.isGMC && (
            <div className="body-actions">
              <div
                className="post-action like"
                onClick={() => this.likeComment()}
              >
                <i className="material-icons">thumb_up</i>
                <span className="action-label">
                  {FakeData.shortDigit(post.likes.length, "Like").data}
                </span>
              </div>
              <div
                className="post-action comment"
                onClick={() =>
                  this.setState({
                    isShowingComments: this.state.isShowingComments
                      ? false
                      : true
                  })
                }
              >
                <i className="material-icons">chat_bubble</i>
                <span className="action-label">
                  {FakeData.shortDigit(post.comments.length, "Comment").data}
                </span>
              </div>
            </div>
          )}

          {post.isGMC && (
            <div className="gmc-action">
              <div className="body-actions">
                <div
                  className="post-action like"
                  onClick={() => this.likeComment()}
                >
                  <i className="material-icons">thumb_up</i>
                  <span className="action-label">
                    {FakeData.shortDigit(post.likes.length, "Like").data}
                  </span>
                </div>
                <div
                  className="post-action comment"
                  onClick={() =>
                    this.setState({
                      isShowingComments: this.state.isShowingComments
                        ? false
                        : true
                    })
                  }
                >
                  <i className="material-icons">chat_bubble</i>
                  <span className="action-label">
                    {FakeData.shortDigit(post.comments.length, "Comment").data}
                  </span>
                </div>
              </div>
              <div className="gmc-comment-category">
                <div
                  data-count={friends.length}
                  className={
                    this.state.commentType === "friends" ? "active" : ""
                  }
                  onClick={() => this.setActiveCategory("friends")}
                >
                  Friends
                </div>
                <div
                  data-count={fans.length}
                  className={this.state.commentType === "fans" ? "active" : ""}
                  onClick={() => this.setActiveCategory("fans")}
                >
                  Fans
                </div>
                <div
                  data-count={rival.length}
                  className={this.state.commentType === "rival" ? "active" : ""}
                  onClick={() => this.setActiveCategory("rival")}
                >
                  Rivals
                </div>
              </div>
            </div>
          )}

          {this.state.isShowingComments && (
            <div
              className={post.isGMC ? "body-comments is-gmc" : "body-comments"}
            >
              <CommentCollection
                filter={this.state.commentType}
                profile={this.props.profile}
                isGMC={post.isGMC}
                user={this.props.user}
                userType={this.props.userType}
                comments={post.comments}
              />
              {this.state.file.url && (
                <div className="img-preload">
                  <img src={this.state.file.url} />
                  {this.state.file.progress <= 99 && (
                    <div className="img-preload-spinner" />
                  )}
                  {this.state.file.progress >= 99 && (
                    <i
                      className="img-preload-delete material-icons"
                      onClick={() => this.deleteMedia()}
                    >
                      delete
                    </i>
                  )}
                </div>
              )}
              {can_comment&&
                <div className="body-comment-input">
                  <img src={this.props.user.image} />
                  <RichTextInputField noEmoji={true} onRawTextChange={(text, rawText, isError)=>{
              this.setState({ value: text, rawContent: rawText, isError });
            }} placeholder={"Write something..."} onKeyPress={e => {
              if (e.keyCode === 13 || e.which === 13) {
                e.preventDefault();
              }
            }} key={postToken} onKeyUp={(e, text, rawText) => this.onEnter(e, text, rawText)} value={this.state.value} onTextChange={e =>
              this.setState({
                value: e.target.value
              })}/>
                  <i className="material-icons">
                    camera_alt<input
                      type="file"
                      accept="image/**"
                      onChange={e => this.onFilePicked(e.target.files[0])}
                      multiple="false"
                      style={{
                        position: "absolute",
                        margin: "-35px 0px 0px -10px",
                        height: "30px",
                        width: "30px",
                        opacity: 0
                      }}
                    />
                  </i>
                </div>
              }
            </div>
          )}
        </div>
        {this.props.isOdd &&
          !post.isGMC && (
            <div className="author-of">
              <div className="pic" style={{
              height: shrinkItems?"60px":"",
              padding: shrinkItems?"10px":"15px"
            }}>
                <img src={post.user.image} style={{
                  height: shrinkItems?"40px":"",
                  width: shrinkItems?"40px":"",
                }}/>
              </div>
              <div className="clip">
                <img src=".././images/corner_me.svg" />
              </div>
            </div>
          )}
      </div>
    );
  }
}

export class CommentCollection extends React.Component {
  constructor(props) {
    super(props);
  }

  getItem(array, key) {
    if (!this.props.isGMC) {
      return array;
    }
    const arr = [];
    array.forEach(item => {
      if (item.type === key) {
        arr.push(item);
      }
    });
    return arr;
  }

  render() {
    const comments = !this.props.filter
      ? this.props.comments
      : this.getItem(this.props.comments, this.props.filter);
    
    return (
      <div
        className={this.props.isGMC ? "comment-list is-gmc" : "comment-list"}
      >
        {comments.map((item, i) => (
          <CommentFor
            key={i}
            profile={this.props.profile}
            isOdd={i % 2 !== 0 ? false : true}
            isGMC={this.props.isGMC}
            comment={item}
            user={this.props.user}
            userType={this.props.userType}
          />
        ))}
      </div>
    );
  }
}

export class ReplyCollection extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="comment-list">
        {this.props.replies.map((item, i) => (
          <ReplyFor
            key={i}
            profile={this.props.profile}
            isOdd={i % 2 !== 0 ? false : true}
            reply={item}
            user={this.props.user}
            userType={this.props.userType}
          />
        ))}
      </div>
    );
  }
}

export class CommentFor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowingComments: false,
      value: this.props.comment.rawContent,
      media: {},
      file: {},
      postToken: Date.now(),
      postEditToken: Date.now()+"_edit",
      isEditting: false,
      val: ""
    };
  }

  componentDidMount(){
    this.getSettings()
  }

  likeComment() {
    const dataTo = {
      user: this.props.user,
      type: "comment",
      contentId: this.props.comment.id,
      userOne: this.props.comment.user,
      userTwo: null,
      users: [],
      userType: this.props.userType
    };
    const _that = this;

    FakeData.post("/likeContent.php?auth0", dataTo, {
      success: res => {
        FakeData.alert("Done!");
      },
      error: err => {}
    });
  }

  getSettings = () => {
		const _that = this;

		FakeData.post('https://supotsu.com:8080/api/settings/get', {
			id: this.props.comment.user.id,
			type: this.props.comment.user.type
		}, {
				headers: {
					'Content-Type': 'application/json'
				},
				success(settings) {
					_that.setState({ settings });
				}
			})
	}

  editComment(e) {
    if (e.keyCode === 13 || e.which === 13) {
      const dataTo = {
        content: this.state.value,
        commentId: this.props.comment.id
      };
      const _that = this;

      FakeData.post(
        "/editComment.php?auth0",
        dataTo,
        {
          success: res => {
            _that.setState({
              isEditting: false
            });
            FakeData.alert("Done!");
          },
          error: err => {}
        },
        true,
        "",
        () => {}
      );
    }
  }

  deleteComment() {
    const dataTo = {
      commentId: this.props.comment.id,
      media: this.props.comment.media
    };
    const _that = this;

    FakeData.post(
      "/deleteComment.php?auth0",
      dataTo,
      {
        success: res => {
          _that.setState({
            isEditting: false
          });
          FakeData.alert("Done!");
        },
        error: err => {}
      },
      true,
      "",
      () => {}
    );
  }

  addReply(e, text = false, rawText = false) {
    
    if (e.keyCode === 13 || e.which === 13) {
      if(this.state.isError){
        alert("Please check your content before you submit...")
        return;
      }
      const dataTo = {
        user: this.props.user,
        commentId: this.props.comment.id,
        content: !text?this.state.val:text,
        rawContent: !rawText?this.state.rawContent:rawText,
        media: this.state.media,
        userOne: this.props.comment.user,
        userTwo: null,
        users: this.props.comment.users,
        userType: this.props.userType
      };

      const _that = this;

      FakeData.post(
        "/createReply.php?auth0",
        dataTo,
        {
          success: res => {
            _that.setState({
              val: "",
              rawContent: "",
              isError: false,
              postToken: Date.now(),
              media: {},
              file: {}
            });
            FakeData.alert("Done!");
          },
          error: err => {}
        },
        true,
        "",
        () => {}
      );
    }
  }

  onSendMedia(media) {
    const dataTo = {
      user: this.props.user,
      commentId: this.props.comment.id,
      content: "",
      rawContent: "",
      media: media,
      userOne: this.props.comment.user,
      userTwo: null,
      users: this.props.comment.users,
      userType: this.props.userType
    };

    const _that = this;

    FakeData.post(
      "/createReply.php?auth0",
      dataTo,
      {
        success: res => {
          _that.setState({
            media: {},
            file: {}
          });
          FakeData.alert("Done!");
        },
        error: err => {}
      },
      true,
      "",
      () => {}
    );
  }

  onFilePicked(file) {
    const _that = this;
    let reader = new FileReader();
    reader.onloadend = () => {
      const newFile = {
        file: file,
        progress: 0,
        url: reader.result
      };

      _that.setState({
        file: newFile
      });

      _that.uploadFile(newFile);
    };
    reader.readAsDataURL(file);
  }

  uploadFile(file) {
    var formdata = new FormData();
    const _that = this;
    formdata.append("file", file.file);
    formdata.append("location", "");
    formdata.append("albumId", 0);
    formdata.append("tags", "");
    formdata.append("userId", this.props.user.id);
    var ajax = new XMLHttpRequest();
    ajax.upload.addEventListener(
      "progress",
      e => {
        let percent = Math.round(e.loaded / e.total * 100);
        _that.state.file.progress = percent;
        _that.setState({
          files: _that.state.files
        });
      },
      false
    );
    ajax.addEventListener(
      "load",
      e => {
        let data = JSON.parse(e.target.responseText);
        if (data.id) {
          data.oldUrl = file.url;
          _that.onSendMedia(data);
        } else {
          _that.setState({ media: {}, file: {} });
          alert("Error uploading file...");
        }
      },
      false
    );
    ajax.open(
      "POST",
      FakeData.URL + "/uploadMedia.php?auth0&userId=" + this.props.user.id
    );
    ajax.send(formdata);
  }

  deleteMedia() {
    const file = this.state.media;
    const _that = this;
    const dataTo = {
      userId: FakeData.getData("yoo").id,
      img: file,
      tags: this.state.tags
    };

    FakeData.post(
      "/removeMedia.php?auth0",
      dataTo,
      {
        success: res => {
          _that.setState({
            media: {},
            file: {}
          });
        },
        error: err => {}
      },
      true,
      "File Was Removed",
      res => {}
    );
  }

  render() {
    const comment = this.props.comment;
    const {postToken, postEditToken, settings} = this.state;
    const _canComment = FakeData.listify(settings).filter((item) => {
			return item.sub === 'can_comment'
		})
    let can_comment = _canComment.length === 0 ? true : _canComment[0]['value'];
		can_comment = FakeData.you().id === comment.user.id ? true : can_comment;
    return (
      <div
        className={
          this.props.isOdd ? "comment-list-item odd" : "comment-list-item"
        }
      >
        <img src={comment.user.image} />
        <div className="comment-list-item-body">
          <div className="content-box">
            <span>
              <Link
                style={
                  this.props.isGMC && this.props.isOdd ? { color: "#29b" } : {}
                }
                to={{
                  pathname:
                    comment.user.type === "F" || comment.user.type === "P"
                      ? "/profile/" + comment.user.user
                      : comment.user.type === "L"
                        ? "/tournament/" + comment.user.user
                        : comment.user.type === "C"
                          ? "/club/" + comment.user.user
                          : comment.user.type === "I"
                            ? "/institution/" + comment.user.user
                            : "/team/" + comment.user.id,
                  search: "?sInit=about"
                }}
              >
                {comment.user.name}
              </Link>{" "}
              <span
                className={"rich-text-content"}
                dangerouslySetInnerHTML={{ __html: FakeData.getRichText(comment.rawContent, comment.contentUsers) }}
              />{" "}
              {this.state.isEditting}
            </span>
            {this.state.isEditting && (
              <textarea
                value={this.state.value}
                style={{
                  marginRight:
                    comment.user.id === this.props.user.id ? "10px" : "40px"
                }}
                onKeyPress={e => {
                  if (e.keyCode === 13 || e.which === 13) {
                    e.preventDefault();
                  }
                }}
                onKeyUp={e => this.editComment(e)}
                onChange={e => this.setState({ value: e.target.value })}
              />
            )}
            {comment.media.id && (
              <img
                src={comment.media.url}
                style={{ width: "100px", height: "100px", borderRadius: "0px" }}
              />
            )}
          </div>
          <div className="body-actions">
            <div
              className="post-action like"
              onClick={() => this.likeComment()}
            >
              <i className="material-icons">thumb_up</i>
              <span className="action-label">
                {FakeData.shortDigit(comment.likes.length, "Like").data}
              </span>
            </div>
            <div
              className="post-action comment"
              onClick={() =>
                this.setState({
                  isShowingComments: this.state.isShowingComments ? false : true
                })
              }
            >
              <i className="material-icons">reply</i>
              <span className="action-label">
                {FakeData.shortDigit(comment.replies.length, "Reply").data}
              </span>
            </div>
          </div>
          {this.state.isShowingComments && (
            <div
              className={
                this.props.isGMC ? "body-comments is-gmc" : "body-comments"
              }
            >
              <ReplyCollection
                replies={comment.replies}
                user={this.props.user}
                profile={this.props.profile}
                userType={this.props.userType}
              />
              {this.state.file.url && (
                <div className="img-preload">
                  <img src={this.state.file.url} />
                  {this.state.file.progress <= 99 && (
                    <div className="img-preload-spinner" />
                  )}
                  {this.state.file.progress >= 99 && (
                    <i
                      className="img-preload-delete material-icons"
                      onClick={() => this.deleteMedia()}
                    >
                      delete
                    </i>
                  )}
                </div>
              )}
              <div className="body-comment-input">
                <img src={this.props.user.image} />
                <RichTextInputField noEmoji={true} onRawTextChange={(text, rawText, isError)=>{
            this.setState({ val: text, rawContent: rawText, isError });
          }} placeholder={"Write something..."} onKeyPress={e => {
            if (e.keyCode === 13 || e.which === 13) {
              e.preventDefault();
            }
          }} key={postToken} onKeyUp={(e, text, rawText) => this.addReply(e, text, rawText)} value={this.state.val} onTextChange={e =>
            this.setState({
              val: e.target.value
            })} textAreaStyle={!this.props.isGMC
              ? {}
              : { background: "#ddd", color: "#333" }}/>
                {this.is &&
                <textarea
                  style={
                    !this.props.isGMC
                      ? {}
                      : { background: "#ddd", color: "#333" }
                  }
                  placeholder="Write something.."
                  onKeyPress={e => {
                    if (e.keyCode === 13 || e.which === 13) {
                      e.preventDefault();
                    }
                  }}
                  onKeyUp={e => this.addReply(e)}
                  value={this.state.val}
                  onChange={e =>
                    this.setState({
                      val: e.target.value
                    })
                  }
                />}
                <i className="material-icons">
                  camera_alt<input
                    type="file"
                    accept="image/**"
                    onChange={e => this.onFilePicked(e.target.files[0])}
                    multiple="false"
                    style={{
                      position: "absolute",
                      margin: "-35px 0px 0px -10px",
                      height: "30px",
                      width: "30px",
                      opacity: 0
                    }}
                  />
                </i>
              </div>
            </div>
          )}
        </div>
        {comment.user.id === this.props.user.id && (
          <div className="body-header-actions">
            {!this.state.isEditting && (
              <i
                className="material-icons"
                onClick={() => this.setState({ isEditting: true })}
              >
                edit
              </i>
            )}
            {this.state.isEditting && (
              <i
                className="material-icons"
                onClick={() => this.deleteComment()}
              >
                delete
              </i>
            )}
            {this.state.isEditting && (
              <i
                className="material-icons"
                onClick={() => this.setState({ isEditting: false })}
              >
                clear
              </i>
            )}
          </div>
        )}
      </div>
    );
  }
}

export class ReplyFor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowingComments: false,
      value: this.props.reply.rawContent,
      isEditting: false
    };
  }

  likeReply() {
    const dataTo = {
      user: this.props.user,
      type: "reply",
      contentId: this.props.reply.id,
      userOne: this.props.reply.user,
      userTwo: null,
      users: [],
      userType: this.props.userType
    };
    const _that = this;

    FakeData.post(
      "/likeContent.php?auth0",
      dataTo,
      {
        success: res => {
          FakeData.alert("Done!");
        },
        error: err => {}
      },
      true,
      "",
      () => {}
    );
  }

  editReply(e) {
    if (e.keyCode === 13 || e.which === 13) {
      const dataTo = {
        content: this.state.value,
        replyId: this.props.reply.id
      };
      const _that = this;

      FakeData.post(
        "/editReply.php?auth0",
        dataTo,
        {
          success: res => {
            _that.setState({
              isEditting: false
            });
            FakeData.alert("Done!");
          },
          error: err => {}
        },
        true,
        "",
        () => {}
      );
    }
  }

  deleteReply() {
    const dataTo = {
      replyId: this.props.reply.id,
      media: this.props.reply.media
    };
    const _that = this;

    FakeData.post(
      "/deleteReply.php?auth0",
      dataTo,
      {
        success: res => {
          _that.setState({
            isEditting: false
          });
          FakeData.alert("Done!");
        },
        error: err => {}
      },
      true,
      "",
      () => {}
    );
  }

  render() {
    const reply = this.props.reply;
    return (
      <div
        className={
          this.props.isOdd
            ? "comment-list-item odd-reply"
            : "comment-list-item even"
        }
      >
        <img src={reply.user.image} />
        <div className="comment-list-item-body">
          <div className="content-box">
            <span>
              <Link
                to={{
                  pathname:
                    reply.user.type === "F" || reply.user.type === "P"
                      ? "/profile/" + reply.user.user
                      : reply.user.type === "L"
                        ? "/tournament/" + reply.user.user
                        : reply.user.type === "C"
                          ? "/club/" + reply.user.user
                          : reply.user.type === "I"
                            ? "/institution/" + reply.user.user
                            : "/team/" + reply.user.id,
                  search: "?sInit=about"
                }}
              >
                {reply.user.name}
              </Link>{" "}
              <span
                className={"rich-text-content"}
                dangerouslySetInnerHTML={{ __html: FakeData.getRichText(reply.rawContent, reply.contentUsers) }}
              />{" "}
              {this.state.isEditting}
            </span>
            {this.state.isEditting && (
              <textarea
                value={this.state.value}
                style={{
                  marginRight:
                    reply.user.id === this.props.user.id ? "10px" : "40px"
                }}
                onKeyPress={e => {
                  if (e.keyCode === 13 || e.which === 13) {
                    e.preventDefault();
                  }
                }}
                onKeyUp={e => this.editReply(e)}
                onChange={e => this.setState({ value: e.target.value })}
              />
            )}
            {reply.media.id && (
              <img
                src={reply.media.url}
                style={{ width: "100px", height: "100px", borderRadius: "0px" }}
              />
            )}
          </div>
          <div className="body-actions">
            <div className="post-action like" onClick={() => this.likeReply()}>
              <i className="material-icons">thumb_up</i>
              <span className="action-label">
                {reply.likes.length / 6 > 1000000
                  ? reply.likes.length / 6 + "m likes"
                  : reply.likes.length / 3 > 1000
                    ? reply.likes.length / 3 + "k likes"
                    : reply.likes.length === 1
                      ? reply.likes.length + " like"
                      : reply.likes.length === 0
                        ? "Like"
                        : reply.likes.length + " likes"}
              </span>
            </div>
            {reply.replies && (
              <div
                className="post-action comment"
                onClick={() =>
                  this.setState({
                    isShowingComments: this.state.isShowingComments
                      ? false
                      : true
                  })
                }
              >
                <i className="material-icons">reply</i>
                <span className="action-label">
                  {reply.replies.length / 6 > 1000000
                    ? reply.replies.length / 6 + "m replies"
                    : reply.replies.length / 3 > 1000
                      ? reply.replies.length / 3 + "k replies"
                      : reply.replies.length === 1
                        ? reply.replies.length + " reply"
                        : reply.replies.length === 0
                          ? "Reply"
                          : reply.replies.length + " replies"}
                </span>
              </div>
            )}
          </div>
        </div>
        {reply.user.id === this.props.user.id && (
          <div className="body-header-actions">
            {!this.state.isEditting && (
              <i
                className="material-icons"
                onClick={() => this.setState({ isEditting: true })}
              >
                edit
              </i>
            )}
            {this.state.isEditting && (
              <i className="material-icons" onClick={() => this.deleteReply()}>
                delete
              </i>
            )}
            {this.state.isEditting && (
              <i
                className="material-icons"
                onClick={() => this.setState({ isEditting: false })}
              >
                clear
              </i>
            )}
          </div>
        )}
      </div>
    );
  }
}

export class TimeLineSlider extends React.Component {
  constructor(props) {
    super(props);
  }

  getItems = (array = []) => {
    const acts = {};

    array.forEach((item, i) => {
      if (acts[item.min] && acts[item.min] instanceof Array) {
        acts[item.min].push(item);
      } else {
        acts[item.min] = [item];
      }
    });

    return acts;
  };

  render() {
    this.props.acts.sort(function(a, b) {
      return b.min - a.min;
    });
    const items = this.getItems(this.props.acts);

    const { box } = this.props;

    return (
      <div
        className="timeline-slider"
        style={{
          top:
            500 - this.props.offset <= 70
              ? "70px"
              : 500 - this.props.offset + "px",
          marginRight: box.x + "px"
        }}
      >
        {Object.keys(items).map((item, i) => (
          <div key={i} className="timeline-slider-item">
            <span>{Math.floor(item / 60)}</span>
            <img src={items[item][0].image} />
          </div>
        ))}
      </div>
    );
  }
}

export class SplitPanel extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="split-panel">
        {this.props.children}
        <UpcominComingGames
          style={{
            top:
              20 + this.props.offset <= 530
                ? "0px"
                : 20 + (this.props.offset - 430) + "px"
          }}
        />
      </div>
    );
  }
}

export class StatView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="stat-view">
        <div className="title-view">
          <span className="title-view-value">
            {this.props.valueOne}
            {this.props.title === "Possesion" ? "%" : ""}
          </span>
          <span className="title-view-title">{this.props.title}</span>
          <span className="title-view-value">
            {this.props.valueTwo}
            {this.props.title === "Possesion" ? "%" : ""}
          </span>
        </div>
        <div className="progress-view">
          <div className="progress-view-left">
            <div
              className="progress-of"
              style={{
                width:
                  this.props.valueOne /
                    (parseInt(this.props.valueOne) +
                      parseInt(this.props.valueTwo)) *
                    100 +
                  "%"
              }}
            />
          </div>
          <div className="progress-view-right">
            <div
              className="progress-of"
              style={{
                width:
                  this.props.valueTwo /
                    (parseInt(this.props.valueOne) +
                      parseInt(this.props.valueTwo)) *
                    100 +
                  "%"
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export class MomentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenComments: false,
      item: null,
      commentType: ""
    };
  }

  setActiveCategory(cat) {
    if (this.state.commentType === cat && this.state.isShowingComments) {
      this.setState({
        //isShowingComments: false,
        commentType: ""
      });
    } else if (this.state.commentType === cat) {
      this.setState({
        commentType: ""
      });
    } else {
      this.setState({
        //isShowingComments: true,
        commentType: cat
      });
    }
  }

  getItem(array, key) {
    const arr = [];
    array.forEach(item => {
      if (item.type === key) {
        arr.push(item);
      }

      if (this.state.item !== null && item.id === this.state.item.id) {
        this.setState({ item: item });
      }
    });
    return arr;
  }

  render() {
    const teamOne = this.props.item.teamOne;
    const teamTwo = this.props.item.teamTwo;
    return (
      <div className="moment-view">
        <div
          className="team-moments"
          style={{
            borderRight:
              teamOne.length === teamTwo.length
                ? "2px solid #ccc"
                : teamOne.length < teamTwo.length
                  ? "0px solid #ccc"
                  : "4px solid #ccc"
          }}
        >
          {teamOne.map((post, i) => (
            <div key={i} className="team-moment">
              <div className="team-moment-content">
                <div className="moment-content">
                  <span>
                    {post.playerOne.name} ({post.playerOne.number})
                  </span>
                  {post.playerTwo.id !== null && (
                    <span>
                      {post.actionToo} : {post.playerTwo.name} ({
                        post.playerTwo.number
                      })
                    </span>
                  )}
                </div>
                <img src={post.image} />
              </div>
              <div className="gmc-action" style={{ marginTop: "10px" }}>
                <div className="body-actions">
                  <div
                    className="post-action like"
                    onClick={() => this.likeComment()}
                  >
                    <i className="material-icons">thumb_up</i>
                    <span className="action-label">
                      {FakeData.shortDigit(post.likes.length, "Like").data}
                    </span>
                  </div>
                  <div className="post-action comment">
                    <i className="material-icons">chat_bubble</i>
                    <span className="action-label">
                      {
                        FakeData.shortDigit(post.comments.length, "Comment")
                          .data
                      }
                    </span>
                  </div>
                </div>
                <div
                  className="gmc-comment-category"
                  onClick={() => {
                    this.setState({
                      item: post,
                      isOpenComments: true
                    });
                  }}
                >
                  {this.getItem(post.comments, "friends").length > 0 && (
                    <div
                      data-count={this.getItem(post.comments, "friends").length}
                      onClick={() => this.setActiveCategory("friends")}
                    >
                      Friends
                    </div>
                  )}
                  {this.getItem(post.comments, "fans").length > 0 && (
                    <div
                      data-count={this.getItem(post.comments, "fans").length}
                      onClick={() => this.setActiveCategory("fans")}
                    >
                      Fans
                    </div>
                  )}
                  {this.getItem(post.comments, "rival").length > 0 && (
                    <div
                      data-count={this.getItem(post.comments, "rival").length}
                      onClick={() => this.setActiveCategory("rival")}
                    >
                      Rivals
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="moment-min" data-min={this.props.item.min}>
          {this.props.item.min + "'"}
        </div>
        <div
          className="team-moments"
          style={{
            borderLeft:
              teamOne.length === teamTwo.length
                ? "2px solid #ccc"
                : teamOne.length > teamTwo.length
                  ? "0px solid #ccc"
                  : "4px solid #ccc"
          }}
        >
          {teamTwo.map((post, i) => (
            <div
              key={i}
              className="team-moment"
              style={{ padding: "5px 20px 20px 50px" }}
            >
              <div className="team-moment-content reverse">
                <div className="moment-content" style={{ textAlign: "right" }}>
                  <span>
                    {post.playerOne.name} ({post.playerOne.number})
                  </span>
                  {post.playerTwo.id !== null && (
                    <span>
                      {post.actionToo} : {post.playerTwo.name} ({
                        post.playerTwo.number
                      })
                    </span>
                  )}
                </div>
                <img src={post.image} />
              </div>
              <div className="gmc-action" style={{ marginTop: "10px" }}>
                <div className="body-actions">
                  <div
                    className="post-action like"
                    onClick={() => this.likeComment()}
                  >
                    <i className="material-icons">thumb_up</i>
                    <span className="action-label">
                      {FakeData.shortDigit(post.likes.length, "Like").data}
                    </span>
                  </div>
                  <div className="post-action comment">
                    <i className="material-icons">chat_bubble</i>
                    <span className="action-label">
                      {
                        FakeData.shortDigit(post.comments.length, "Comment")
                          .data
                      }
                    </span>
                  </div>
                </div>
                <div
                  className="gmc-comment-category"
                  onClick={() => {
                    this.setState({
                      item: post,
                      isOpenComments: true
                    });
                  }}
                >
                  {this.getItem(post.comments, "friends").length > 0 && (
                    <div
                      data-count={this.getItem(post.comments, "friends").length}
                      onClick={() => this.setActiveCategory("friends")}
                    >
                      Friends
                    </div>
                  )}
                  {this.getItem(post.comments, "fans").length > 0 && (
                    <div
                      data-count={this.getItem(post.comments, "fans").length}
                      onClick={() => this.setActiveCategory("fans")}
                    >
                      Fans
                    </div>
                  )}
                  {this.getItem(post.comments, "rival").length > 0 && (
                    <div
                      data-count={this.getItem(post.comments, "rival").length}
                      onClick={() => this.setActiveCategory("rival")}
                    >
                      Rivals
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {this.state.isOpenComments &&
          this.state.item !== null && (
            <MomentCommentPopup
              isOpen={this.state.isOpenComments}
              post={this.state.item}
              active={this.state.commentType}
              onClose={() => {
                this.setState({
                  item: null,
                  isOpenComments: false
                });
              }}
            />
          )}
      </div>
    );
  }
}

class MomentCommentPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "Friends",
      value: "",
      media: {},
      file: {}
    };

    this.onEnter = this.onEnter.bind(this);
  }

  getItem(array, key) {
    const arr = [];
    array.forEach(item => {
      if (item.type === key) {
        arr.push(item);
      }
    });
    return arr;
  }

  onEnter(e) {
    if (e.keyCode === 13 || e.which === 13) {
      const dataTo = {
        user: FakeData.getData("yoo"),
        postId: this.props.post.id,
        content: this.state.value,
        type: "gmc-post",
        media: this.state.media,
        userOne: this.props.post.user,
        userTwo: this.props.post.userTo,
        users: this.props.post.tags,
        userType: "F"
      };

      const _that = this;

      FakeData.post(
        "/createComment.php?auth0",
        dataTo,
        {
          success: res => {
            _that.setState({
              value: "",
              media: {},
              file: {}
            });
            FakeData.alert("Comment was posted!");
          },
          error: err => {}
        },
        true,
        "",
        () => {}
      );
    }
  }

  onFilePicked(file) {
    const _that = this;
    let reader = new FileReader();
    reader.onloadend = () => {
      const newFile = {
        file: file,
        progress: 0,
        url: reader.result
      };

      _that.setState({
        file: newFile
      });

      _that.uploadFile(newFile);
    };
    reader.readAsDataURL(file);
  }

  uploadFile(file) {
    var formdata = new FormData();
    const _that = this;
    formdata.append("file", file.file);
    formdata.append("location", "");
    formdata.append("albumId", 0);
    formdata.append("tags", "");
    formdata.append("userId", this.props.user.id);
    var ajax = new XMLHttpRequest();
    ajax.upload.addEventListener(
      "progress",
      e => {
        let percent = Math.round(e.loaded / e.total * 100);
        _that.state.file.progress = percent;
        _that.setState({
          files: _that.state.files
        });
      },
      false
    );
    ajax.addEventListener(
      "load",
      e => {
        let data = JSON.parse(e.target.responseText);
        if (data.id) {
          data.oldUrl = file.url;
          _that.setState({
            media: data
          });
        } else {
          _that.setState({ media: {}, file: {} });
          alert("Error uploading file...");
        }
      },
      false
    );
    ajax.open(
      "POST",
      FakeData.URL + "/uploadMedia.php?auth0&userId=" + this.props.user.id
    );
    ajax.send(formdata);
  }

  deleteMedia() {
    const file = this.state.media;
    const _that = this;
    const dataTo = {
      userId: FakeData.getData("yoo").id,
      img: file,
      tags: []
    };

    FakeData.post(
      "/removeMedia.php?auth0",
      dataTo,
      {
        success: res => {
          _that.setState({
            media: {},
            file: {}
          });
        },
        error: err => {}
      },
      true,
      "File Was Removed",
      res => {}
    );
  }

  render() {
    const { post } = this.props;
    const comments = this.getItem(
      post.comments,
      this.state.active.toLowerCase()
    );

    return (
      <Modal
        isOpen={this.props.isOpen}
        onClose={() => {
          this.props.onClose();
        }}
      >
        <div
          style={{
            width: "45vw",
            height: "60vh",
            overflow: "hidden",
            background: "#fff"
          }}
        >
          <div
            style={{
              width: "100%",
              height: "50px",
              background: "#345",
              display: "flex"
            }}
          >
            {["Friends", "Fans", "Rivals"].map((item, i) => {
              return (
                <div
                  style={{
                    width: "calc(100% / 3)",
                    lineHeight: "50px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  className={
                    this.state.active === item
                      ? "moment-tab-item active"
                      : "moment-tab-item"
                  }
                  onClick={() => {
                    this.setState({
                      active: item
                    });
                  }}
                  key={item}
                >
                  {item}
                </div>
              );
            })}
          </div>
          <div
            style={{
              width: "100%",
              height: "calc(100% - 50px)",
              overflow: "hidden",
              padding: "10px",
              background: "#fff",
              display: "flex",
              flexDirection: "column"
            }}
            className={"body-comments"}
          >
            <div
              style={{
                width: "100%",
                flex: 1,
                overflowX: "hidden",
                overflowY: "auto"
              }}
            >
              {comments.map((item, i) => {
                return (
                  <CommentFor
                    isOdd={i % 2 !== 0 ? false : true}
                    isGMC={true}
                    key={i}
                    comment={item}
                    user={FakeData.getData("yoo")}
                    userType={"F"}
                  />
                );
              })}
            </div>
            {this.state.file.url && (
              <div className="img-preload">
                <img src={this.state.file.url} />
                {this.state.file.progress <= 99 && (
                  <div className="img-preload-spinner" />
                )}
                {this.state.file.progress >= 99 && (
                  <i
                    className="img-preload-delete material-icons"
                    onClick={() => this.deleteMedia()}
                  >
                    delete
                  </i>
                )}
              </div>
            )}
            <div key={this.state.active} className="body-comment-input">
              <img src={FakeData.getData("yoo").image} />
              <textarea
                placeholder="Write something.."
                onKeyPress={e => {
                  if (e.keyCode === 13 || e.which === 13) {
                    e.preventDefault();
                  }
                }}
                onKeyUp={this.onEnter}
                value={this.state.value}
                onChange={e =>
                  this.setState({
                    value: e.target.value
                  })
                }
              />
              <i className="material-icons">
                camera_alt<input
                  type="file"
                  accept="image/**"
                  onChange={e => this.onFilePicked(e.target.files[0])}
                  multiple="false"
                  style={{
                    position: "absolute",
                    margin: "-35px 0px 0px -10px",
                    height: "30px",
                    width: "30px",
                    opacity: 0
                  }}
                />
              </i>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export class MomentTextView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenComments: false,
      item: null,
      commentType: ""
    };
  }

  setActiveCategory(cat) {
    if (this.state.commentType === cat && this.state.isShowingComments) {
      this.setState({
        //isShowingComments: false,
        commentType: ""
      });
    } else if (this.state.commentType === cat) {
      this.setState({
        commentType: ""
      });
    } else {
      this.setState({
        //isShowingComments: true,
        commentType: cat
      });
    }
  }

  getItem(array, key) {
    const arr = [];
    array.forEach(item => {
      if (item.type === key) {
        arr.push(item);
      }

      if (this.state.item !== null && item.id === this.state.item.id) {
        this.setState({ item: item });
      }
    });
    return arr;
  }

  render() {
    const post = this.props.item;
    return (
      <div
        className="text-moment-view"
        style={
          !this.props.isOdd
            ? {
                background: "rgba(77,162,201,0.15)",
                borderTop: "0.5px solid rgba(77,162,201,0.30)",
                borderBottom: "0.5px solid rgba(77,162,201,0.30)"
              }
            : {}
        }
      >
        <h1
          style={{
            fontSize: "25px",
            lineHeight: "25px",
            margin: "0 0 10px 0",
            color: "#4ea3c9"
          }}
        >
          {post.minute + "'"} {post.action} {post.team.name}
        </h1>
        <h2
          style={{
            fontSize: "20px",
            lineHeight: "20px",
            margin: "0 0 5px 0",
            color: "#666"
          }}
        >
          {post.playerOne.name} ({post.playerOne.number})
        </h2>
        {post.playerTwo.id !== null && (
          <h3
            style={{
              fontSize: "18px",
              lineHeight: "18px",
              margin: "0 0 5px 0",
              color: "#777"
            }}
          >
            {post.actionToo} : {post.playerTwo.name} ({post.playerTwo.number})
          </h3>
        )}
        <p>{post.content}</p>
        <div className="gmc-action" style={{ marginTop: "10px" }}>
          <div className="body-actions" style={{ width: "30%" }}>
            <div
              className="post-action like"
              onClick={() => this.likeComment()}
            >
              <i className="material-icons">thumb_up</i>
              <span className="action-label">
                {FakeData.shortDigit(post.likes.length, "Like").data}
              </span>
            </div>
            <div className="post-action comment">
              <i className="material-icons">chat_bubble</i>
              <span className="action-label">
                {FakeData.shortDigit(post.comments.length, "Comment").data}
              </span>
            </div>
          </div>
          <div
            className="gmc-comment-category"
            style={{ flex: "initial" }}
            onClick={() => {
              this.setState({
                item: post,
                isOpenComments: true
              });
            }}
          >
            {this.getItem(post.comments, "friends").length > 0 && (
              <div
                data-count={this.getItem(post.comments, "friends").length}
                onClick={() => this.setActiveCategory("friends")}
              >
                Friends
              </div>
            )}
            {this.getItem(post.comments, "fans").length > 0 && (
              <div
                data-count={this.getItem(post.comments, "fans").length}
                onClick={() => this.setActiveCategory("fans")}
              >
                Fans
              </div>
            )}
            {this.getItem(post.comments, "rival").length > 0 && (
              <div
                data-count={this.getItem(post.comments, "rival").length}
                onClick={() => this.setActiveCategory("rival")}
              >
                Rivals
              </div>
            )}
          </div>
        </div>
        {this.state.isOpenComments &&
          this.state.item !== null && (
            <MomentCommentPopup
              isOpen={this.state.isOpenComments}
              post={this.state.item}
              active={this.state.commentType}
              onClose={() => {
                this.setState({
                  item: null,
                  isOpenComments: false
                });
              }}
            />
          )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GAME.js